import ExtendableError from './ExtendableError';

export default class ErrorResponse extends ExtendableError
{
    constructor(message, errors, result)
    {
        super(message);
        this.errors = errors;
        this.result = result;
    }
}


// WEBPACK FOOTER //
// ./src/graphql/ErrorResponse.js